import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Agency from './pages/Agency';
import Contact from './pages/Contact';
import Services from './pages/Services';
import About from './pages/About';
import Offerings from './pages/Offerings';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import Work from './pages/Work';
import LegalPage from './pages/LegalPage';
import { privacyPolicy, termsOfService, cookiePolicy } from './data/legal';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Agency />} />
          <Route path="/about" element={<About />} />
          <Route path="/what-we-offer" element={<Offerings />} />
          <Route path="/services" element={<Services />} />
          <Route path="/work" element={<Work />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<LegalPage doc={privacyPolicy} />} />
          <Route path="/cookie-policy" element={<LegalPage doc={cookiePolicy} />} />
          <Route path="/terms-of-service" element={<LegalPage doc={termsOfService} />} />
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
